<template>
  <div class="red-resources">
    <div class="container content">
      <el-image
        class="banner"
        fit="cover"
        :src="require(site !== 'tjxd' ? '@/assets/images/tjhj/red-resources-banner.png' : '@/assets/images/tjxd/red-resources-banner.png')"
      ></el-image>
      <el-row class="resource-list card-shadow">
        <el-col
          :sm="12"
          class="resource-item-wrapper"
          v-for="(item, index) in resources"
          :key="index"
        >
          <div class="resource-item can-click" @click="viewResource(item)">
            <i class="iconfont iconhongseziyuan1"></i>
            <span class="name">{{ item.name }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { redResources } from "@/api/mock.js";

export default {
  name: "redResources",
  data() {
    return {
      site: "",
      resources: []
    };
  },
  created() {
    this.site = this.$route.meta;

    redResources()
      .then(res => {
        // 返回数据
        this.resources = res.list;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    viewResource(item) {
      window.open(item.link);
    }
  }
};
</script>

<style scoped lang="scss">
.tjhj .card-shadow {
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.16);
}
.fjkf{
  .content{
    margin-top: 0px;
  }
  .red-resources{
    padding-top: 40px;
  }
}
.content {
  margin-top: 40px;
  margin-bottom: 80px;
}

.tjxd .content {
  margin-top: 30px;
}

.banner {
  display: block;
  height: 120px;
}

.tjxd .banner {
  height: 80px;
}

.resource-list {
  background-color: #fff;
}

.resource-item {
  padding-left: 40px;
  padding-right: 40px;
  height: 55px;
  /* 文字下沉避免视差 */
  line-height: 57px;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.resource-item-wrapper:nth-child(4n + 1),
.resource-item-wrapper:nth-child(4n + 2) {
  background-color: #f8f8f8;
}

.resource-item .iconfont {
  margin-right: 10px;
  font-size: 12px;
  color: #d9ae73;
}

.tjxd .resource-item .iconfont {
  color: #ff8700;
}

@media (max-width: 767px) {
  .container {
    padding: 0;
  }

  .content {
    margin-top: 0;
    margin-bottom: 30px;
  }

  .tjxd .content {
    margin-top: 0;
  }

  .banner {
    height: 70px;
  }

  .tjxd .banner {
    display: none;
  }

  .resource-list {
    background-color: unset;
  }

  .resource-item {
    padding-left: 15px;
    padding-right: 15px;
    height: 50px;
    line-height: 52px;
    font-size: 14px;
  }

  .resource-item-wrapper:nth-child(4n + 1),
  .resource-item-wrapper:nth-child(4n + 2) {
    background-color: unset;
  }

  .resource-item-wrapper:nth-child(2n) {
    background-color: #f8f8f8;
  }
}
</style>
